import { NextSeo } from "next-seo";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Newsletter from "../../components/Footer/components/Newsletter/Newsletter";
import Hero from "./components/Hero/Hero";
import Card from "./components/Card/Card";
import { Meetups } from "../../../common/types";

interface MeetupsProps {
    meetups: Meetups[];
}

export default function MeetupsScreen({ meetups }: MeetupsProps) {
    return (
        <div className="">
            <Header />
            <NextSeo
                title="Dzobs.com | IT meetupi i okupljanja u Bosni i Hercegovini"
                description="Lista IT okupljanja na teritoriji Bosne i Hercegovine. Saznajte gdje su najzanimljiviji događaji i prijavite se za učešće."
                canonical="https://www.dzobs.com/meetups"
                openGraph={{
                    images: [
                        {
                            url: "https://www.dzobs.com/social.png",
                        },
                    ],
                }}
            />
            <Hero
                title="Meetups"
                subheading="Okupljanja IT zajednice"
                subtitle="Lista svih okupljanja iz IT zajednice na prostoru Bosne i Hercegovine. Pretplatite se da vam direktno na mail stižu notifikacije o okupljanjima. Trenutno u BIH je jako malo meetupa pa ne brinite za spam :)"
            />
            <div className="relative mb-20 -mt-24 max-w-screen-xl mx-auto px-6 lg:px-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {meetups.length > 0 &&
                    meetups.map((post) => <Card key={post._id} post={post} />)}
            </div>
            <Newsletter bg="bg-gray-light" />
            <Footer />
        </div>
    );
}
